// Global
import React from 'react';

// Local
import { RecipeDetail } from './RecipeDetail';
import { useSitecoreContext } from 'lib/hooks/useSitecoreContext';
import { RecipeResponse } from 'lib/services/models/content-response';

function RecipeDetailWrapper() {
  const { sitecoreContext } = useSitecoreContext();
  const rdpRecipe = sitecoreContext.contentItem as RecipeResponse;

  const { videoTranscriptUrls, videoWithAudioDescriptionURL, siteSettings, contributor } =
    sitecoreContext;

  return (
    <RecipeDetail
      recipe={rdpRecipe}
      videoTranscriptUrls={videoTranscriptUrls}
      videoWithAudioDescriptionURL={videoWithAudioDescriptionURL as string}
      siteSettings={siteSettings}
      contributor={contributor}
    />
  );
}

export const Default = RecipeDetailWrapper;
